// extracted by mini-css-extract-plugin
export default {"routeItem":"RouteItem_routeItem__MhFOV","info":"RouteItem_info__0Er8O","longName":"RouteItem_longName__UlWIa"};